var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("Açıklama alanındaki anahtar kelime yoğunluğu: "),_c('b',[_vm._v("%"+_vm._s(_vm.percent))]),_vm._v(". Tavsiye edilen en fazla "),_c('b',[_vm._v("%3")])])])}
var staticRenderFns = []

export { render, staticRenderFns }